import React, { useState, useEffect } from 'react'
import { getLocalPath, isMobile } from '../../../spa/utility/index.js'
import './welcomeModal.css'
import DOMPurify from 'dompurify'

function WelcomeModal({ profileData, mode = 'LEAD' }) {
  const [showModal, setShowModal] = useState(true)
  function resizeEvent() {
    const overflow = isMobile() ? 'hidden' : ''
    document.getElementsByTagName('html')[0].style.overflow = overflow
  }
  const removeEvent = () => {
    window.removeEventListener('resize', resizeEvent)
    document.getElementsByTagName('html')[0].style.overflow = ''
  }

  const onCloseClick = () => {
    setShowModal(false)
    removeEvent()
  }

  useEffect(() => {
    window.addEventListener('resize', resizeEvent)
    return () => {
      removeEvent()
    }
  }, [])

  return showModal ? (
    <div
      className="Modal"
      id="welcome-modal"
      data-analytics="cti-registration-modal"
    >
      <dialog className="Modal-window">
        <header className="Modal-header">
          <h3 className="u-paddingRight2gu u-textColorBrand">
            Thanks for registering, {profileData.preferredFirstNm}.
          </h3>
          <button
            id="closeWelcomModal"
            className="Button Button--icon Modal-icon-button--close u-decoBackgroundBrand"
            onClick={onCloseClick}
            data-analytics="cti-registration-modal-close"
          >
            <span className="u-hiddenVisually">Close this dialog</span>
            <span aria-hidden="true" className="material-symbols-outlined">
              close
            </span>
          </button>
        </header>
        <div className="Modal-content">
          {mode === 'LEAD' ? (
            <p className="u-marginBottom4gu">
              You&rsquo;ll have guest access to the site for up to 10 business
              days while we validate your information. Not sure where to start?
              Make the most of our site with these recommendations.
            </p>
          ) : (
            <p className="u-marginBottom4gu">
              Not sure where to start? Make the most of our site with these
              recommendations:
            </p>
          )}
          <div className="Grid Grid--withGutter">
            {[
              {
                icon: 'eye',
                title: 'Timely insights',
                content:
                  'Stay informed with market outlooks and timely insights from our global asset allocation team and thought leaders.',
                buttonText: 'Read our insights',
                buttonLink: '/insights',
              },
              {
                icon: 'checklist',
                title: 'Practice management',
                content:
                  'Explore business-building ideas designed to help you expand and grow your practice.',
                buttonText: 'Explore our resources',
                buttonLink: '/insights/practice-management',
              },
              {
                icon: 'handshake',
                title: 'Personalized advice',
                content:
                  "Contact your sales consultant team for suggestions on how our tools, resources and solutions can help meet your clients' needs.",
                buttonText: 'Meet your consultants',
                buttonLink: '/about/contact-us',
              },
            ].map((el, index) => {
              return (
                <div
                  className="u-size1of3  u-md-sizeFull u-sm-sizeFull u-flex"
                  key={`${el}-${index}`}
                >
                  <div className="Card u-flex u-flexWrap u-flexAlignContentBetween u-flexJustifyCenter u-paddingHoriz4gu">
                    <div className="u-flex u-flexCol u-flexAlignItemsCenter">
                      <img
                        className="u-marginBottom3gu"
                        src={DOMPurify.sanitize(
                          `${getLocalPath()}/binaries/content/gallery/cti-institutional/icons/${
                            el.icon
                          }.svg`
                        )}
                        alt="alt"
                        id={`${el.title.replace(/[^\w]/g, '-').toLowerCase()}${
                          el.icon
                        }-icon`}
                        width="90px"
                      />
                      <h3 className="u-textColorBrand u-textCenter u-marginBottom3gu">
                        {el.title}
                      </h3>
                      <p className="u-textCenter u-marginBottom3gu">
                        {el.content}
                      </p>
                    </div>
                    <a
                      className="Button Button--secondary u-textNoTransform u-flexAlignSelfEnd u-paddingHoriz3gu"
                      href={el.buttonLink}
                      data-analytics="cti-registration-modal-action-buttons"
                    >
                      {el.buttonText}
                    </a>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </dialog>
    </div>
  ) : null
}

export default WelcomeModal
